import React from 'react';
import "./NeoButton.scss";


interface NeoButtonProps<T = any> {
    text: string;
    onClick?: (data: T) => void | Promise<void>;
}

export const NeoButton: React.FC<NeoButtonProps> = ({text, onClick}) => {
    return (
        <button className="neo-button" onClick={onClick}>
            <span className="neo-button-text">{text}</span>
        </button>
    )
};